import styled from "styled-components";
import SVG from "react-inlinesvg";
import { SelectDropdown } from "../../Assets/icons";

export const CalendarContainer = styled.div`
    background: ${props => (props.$container === 'popup' ? '#FFF' : '#F6F6F6')};
    border-radius: 5px;
    box-sizing: border-box;
    height: 460px;
    margin-bottom: ${props => (props.$container === 'popup' ? '10px' : '0')};
    padding: 10px;
    position: relative;
    width: ${props => (props.$container === 'popup' ? '100%' : '328px')};

    h2 {
        color: #333;
        font-size: 24px;
        font-weight: 700;
        margin-bottom: 16px;
    }

    .header{
        display: flex; 
        gap: 16px;
    }

    select{
        appearance: none; 
        background: url(${SelectDropdown}) right 5px center / 14px no-repeat;
        border: 1px solid #006560;
        border-radius: 5px;
        color: #333;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 16px;
        padding: 5px 28px 5px 8px;

        -moz-appearance: none;
        -webkit-appearance: none; 
    }

    option{
        border: 1px solid transparent;
        border-radius: 5px;
        color: #333;
        font-size: 16px;
        font-weight: 600;
        padding: 10px;
        &:hover{
            background: #F6F6F6;
            border-color: #33CC99;
            
        }
    }

    .calendar-grid{
        display: grid;
        gap: 8px;
        grid-template-columns: repeat(7, 1fr);
        max-width: 100%;
        text-align: center;
    }

    .header-row {
        background: #CBEDE2; 
        border-radius: 5px;
        display: grid;
        gap: 8px;
        grid-column: span 7; 
        grid-template-columns: repeat(7, 1fr);
        padding: 4px 0;
    }

    .day-header {
        color: #333;
        cursor: default;
        font-size: 18px;
        font-weight: 400;
        list-style: none;
        padding: 8px;
    }

    .empty-slot {
        visibility: hidden;
    }

    .day-cell {
        border: 1px solid transparent;
        color: #333;
        cursor: default;
        padding: 6px;

        &:hover{
            border-color: #33CC99;
            border-radius: 3px;
            font-weight: 600;
        }
    }

    .selected-day {
        background-color: #33CC99; /* Tailwind green-400 */
        border-radius: 3px;
        color: white;
    }

    button{
        bottom: 10px;
        font-size: 18px;
        font-weight: 600;
        padding: 8px 12px;
        position: absolute;
        right: 10px;
        text-transform: uppercase;
    }
`;

export const BackIcon = styled(SVG)`   
    height: 20px;
    width: 20px;
`;